/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

// The editor creator to use.
import ClassicEditorBase from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
//import UploadAdapter from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
//import CKFinder from '@ckeditor/ckeditor5-ckfinder/src/ckfinder';
import EasyImage from '@ckeditor/ckeditor5-easy-image/src/easyimage';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import Indent from '@ckeditor/ckeditor5-indent/src/indent';
import Link from '@ckeditor/ckeditor5-link/src/link';
import List from '@ckeditor/ckeditor5-list/src/list';
//import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
//import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';
//import Table from '@ckeditor/ckeditor5-table/src/table';
//import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';
//import TextTransformation from '@ckeditor/ckeditor5-typing/src/texttransformation';
//import CloudServices from '@ckeditor/ckeditor5-cloud-services/src/cloudservices';

import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import Font from '@ckeditor/ckeditor5-font/src/font';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import Strikethrough from '@ckeditor/ckeditor5-basic-styles/src/strikethrough';
import LinkImage from '@ckeditor/ckeditor5-link/src/linkimage';
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize';
import AutoImage from '@ckeditor/ckeditor5-image/src/autoimage';
import LimpiarContenido from '/limpiar-contenido/limpiar-contenido';
import TamanoTexto from '/tamano-texto/tamano-texto';

import ImageEditing from '@ckeditor/ckeditor5-image/src/image/imageediting';
import Mention from '@ckeditor/ckeditor5-mention/src/mention';

export default class ClassicEditor extends ClassicEditorBase {}

function MentionCustomization( editor ) {
    // The upcast converter will convert view <a class="mention" href="" data-user-id="">
    // elements to the model 'mention' text attribute.
    editor.conversion.for( 'upcast' ).elementToAttribute( {
        view: {
            name: 'a',
            key: 'data-mention',
            classes: 'mention',
            attributes: {
                href: true,
                'data-id-elemento': true,
				'data-tipo-contenido':true
            }
        },
        model: {
            key: 'mention',
            value: viewItem => {
                // The mention feature expects that the mention attribute value
                // in the model is a plain object with a set of additional attributes.
                // In order to create a proper object use the toMentionAttribute() helper method:
                const mentionAttribute = editor.plugins.get( 'Mention' ).toMentionAttribute( viewItem, {
                    // Add any other properties that you need.
                    link: viewItem.getAttribute( 'href' ),
                    id_elemento: viewItem.getAttribute( 'data-id-elemento' ),
					tipo_contenido: viewItem.getAttribute( 'data-tipo-contenido' )
                } );

                return mentionAttribute;
            }
        },
        converterPriority: 'high'
    } );

    // Downcast the model 'mention' text attribute to a view <a> element.
    editor.conversion.for( 'downcast' ).attributeToElement( {
        model: 'mention',
        view: ( modelAttributeValue, { writer } ) => {
            // Do not convert empty attributes (lack of value means no mention).
            if ( !modelAttributeValue ) {
                return;
            }
			console.log(modelAttributeValue);
            return writer.createAttributeElement( 'a', {
                class: 'mention',
                'data-mention': modelAttributeValue.id,
                'data-id-elemento': modelAttributeValue.id_elemento,
				'data-tipo-contenido': modelAttributeValue.tipo_contenido,
                'href': modelAttributeValue.link
            }, {
                // Make mention attribute to be wrapped by other attribute elements.
                priority: 20,
                // Prevent merging mentions together.
                id: modelAttributeValue.uid
            } );
        },
        converterPriority: 'high'
    } );
}

// Plugins to include in the build.
ClassicEditor.builtinPlugins = [
	Essentials,
	//UploadAdapter,
	Autoformat,
	Bold,
	Italic,
	BlockQuote,
	//CKFinder,
	//CloudServices,
	//EasyImage,
	Heading,
	Image,
	ImageCaption,
	ImageStyle,
	ImageToolbar,
	ImageUpload,
	Indent,
	Link,
	LinkImage,
	List,
	//MediaEmbed,
	Paragraph,
	//PasteFromOffice,
	//Table,
	//TableToolbar,
	//TextTransformation,
    Alignment,
    Font,
    Underline,
    Strikethrough,
	ImageResize,
	AutoImage,
	LimpiarContenido,
	TamanoTexto,
	ImageEditing,
	Mention,
	MentionCustomization
];

// Editor configuration.
ClassicEditor.defaultConfig = {
	toolbar: {
		items: [
			"Bold",
			'|',
			"Italic",
			'|',
			"Underline",
			'|',
			"Strikethrough",
			'|',
			"FontFamily",
			//"FontSize",
			"tamanoTexto",
			"Link" ,
			'|',
			'blockQuote',
			'|',
			'alignment:left',
			'alignment:center',
			'alignment:right',
			'|',
			'FontBackgroundColor',
			'|',
			"FontColor",
			'|',
			"bulletedList",
			"numberedList",			
			'|',
			'limpiarContenido',
			'|',
			'undo',
			'redo'			
			
		]
	},
	image: {
		toolbar: [
			'imageStyle:block',
            'imageStyle:side',
            'imageStyle:inline',
            '|',
            'linkImage'
		]
	},
	fontSize: {
		options: [
			9,
			10,
			11,
			12,
			13,
			14,
			15,
			16,
			17,
			19,
			21
		]
	},
	table: {
		contentToolbar: [
			'tableColumn',
			'tableRow',
			'mergeTableCells'
		]
	},
	// This value must be kept in sync with the language defined in webpack.config.js.
	language: 'es'
};
